<template>
    <div class="totalForm">
        <div class="histogramView">
            <p>收益走势单位：元</p>
            <ve-histogram :data="chartData" :loading="loading" :data-empty="!loading && chartData.rows.length === 0"
                :legend-visible="false" height='57.6vw' :extend="chartExtend" />
        </div>
        <div class="totalView">
            <div class="itemView van-hairline--bottom">
                <div class="item">
                    <div class="itemContent buleView">

                        <span class="totalAmount">{{ totalObj.totalAmount }}</span>
                        <span class="totalAmountDesc">累计收益(元)</span>
                    </div>
                </div>
                <div class="item">
                    <div class="itemContent orangeView">

                        <span class="totalAmount">{{ totalObj.totalDeviceCount }}</span>
                        <span class="totalAmountDesc">总设备数(台)</span>
                    </div>
                </div>
            </div>
            <div class="itemView">
                <div class="item">
                    <div class="itemContent greenView">

                        <span class="totalAmount">{{ totalObj.totalOrderCount }}</span>
                        <span class="totalAmountDesc">总订单量</span>
                    </div>
                </div>
                <div class="item">
                    <div class="itemContent purpleView">

                        <span class="totalAmount">{{ totalObj.totalStoreCount }}</span>
                        <span class="totalAmountDesc">总网点</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 4:41 下午
* 总报表
*/
import { getReportAll } from "../../api/reportForms";

export default {
    name: "totalForm",
    data() {
        return {
            chartExtend: {
                grid: {
                    top: '10%',
                    bottom: '4%',
                    containLabel: true
                },
                barWidth: 10,
                series: {
                    label: { show: true, position: "top" }
                }
            },
            chartData: {
                columns: ['monthName', 'moneyYuan'],
                rows: []
            },
            totalObj: {
                totalAmount: 0, totalDeviceCount: 0, totalOrderCount: 0, totalStoreCount: 0
            },
            loading: true
        }
    },
    created() {
        getReportAll().then(result => {
            this.loading = false;
            let { totalAmount, totalDeviceCount, totalOrderCount, totalStoreCount, nearMonthMoneyDtos } = result;
            this.totalObj = {
                totalAmount, totalDeviceCount, totalOrderCount, totalStoreCount
            };
            this.chartData.rows = nearMonthMoneyDtos;
        })
    }
}
</script>

<style lang='less' scoped>
.totalForm {
    .histogramView {
        margin: 3.2vw 0;
        padding-top: 3.87vw;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);

        p {
            text-indent: 2em;
            font-size: 2.67vw;
            color: #c6c6c6;
        }
    }

    .totalView {
        height: 48.47vw;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
    }

    .totalView .itemView {
        display: flex;
        justify-content: space-between;
        height: 50%;
    }

    .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        padding: 2.67vw;
        box-sizing: border-box;
        display: flex;

        .itemContent {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 2.67vw;
            background-color: #43a2fe;

            .totalAmountDesc {
                font-size: 3vw;
                color: rgba(107, 114, 128, 1);
            }
             .totalAmount {
                font-size: 5.33vw;
                font-weight: bold;
             }
        }

        .buleView {
            background-color: rgba(67, 162, 254, 0.05);

            .totalAmount {
                color: rgba(67, 162, 254, 1);
            }
        }

        .orangeView {
            background-color: rgba(255, 247, 237,1);

            .totalAmount {
                color: rgba(249, 115, 22, 1);
            }
        }

        .greenView {
            background-color: rgba(240, 253, 244,1);

            .totalAmount {
                color: rgba(34, 197, 94, 1);
            }
        }

        .purpleView {
            background-color: rgba(250, 245, 255,1);

            .totalAmount {
                color: rgba(168, 85, 247, 1);
            }
        }



    }


}
</style>



// WEBPACK FOOTER //
// src/page/reportForms/totalForm.vue